import { useState } from "react";
import Image from "components/base/Image";
import Trans from "components/base/Trans";
import Play from "components/icons/Play";
import Date from "components/blog/Date";
import Text from "components/base/Text";
import { MotionBox as Box, MotionFlex as Flex } from "utils/motion";

const hoverVariants = {
  hover: { scale: 1.1, transition: { type: "tween", duration: 0.5 } },
  regular: { scale: 1, transition: { type: "tween", duration: 0.5 } },
};

const VideoItem = ({ data, ...props }) => {
  const [hovering, setHovering] = useState(false);

  return (
    <Box {...props} mb="xl">
      <Box
        style={{ cursor: "pointer" }}
        onHoverStart={() => setHovering(true)}
        onHoverEnd={() => setHovering(false)}
      >
        <Box overflow="hidden" position="relative">
          <Box
            pt="52.6%"
            position="relative"
            initial="regular"
            bg="black.900"
            variants={hoverVariants}
            animate={hovering ? "hover" : "regular"}
          >
            <Image
              src={data.thumbnail.url}
              objectFit="cover"
              objectPosition="center"
              style={{ position: "absolute" }}
              top="0"
              bottom="0"
              left="0"
              right="0"
            />
          </Box>
          <Flex
            position="absolute"
            bottom={3}
            alignItems="center"
            justifyContent="space-between"
            px={3}
            zIndex={1}
            width="100%"
          >
            {data.episode_number && (
              <Text type="title_md" color="white" fontWeight="500">
                <Trans
                  id="LBL_EPISODE"
                  values={{ number: data.episode_number }}
                />
              </Text>
            )}
            <Play color="white" size="24px" />
          </Flex>
          <Box
            w="100%"
            h="100%"
            position="absolute"
            top={0}
            style={{
              backgroundImage:
                "linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0.9))",
            }}
          />
        </Box>
        <Flex
          align="flex-end"
          minH="50px"
          justify="space-between"
          py={[2, null, 3]}
        >
          <Text
            type="title_sm"
            w="85%"
            color={props.color}
            _hover={{ textDecoration: "underline" }}
          >
            {data.title[0].text}
          </Text>
          <Text type="p_sm" color={props.color}>
            {data.time || "1"}m
          </Text>
        </Flex>
        <Date date={data.published_date} />
        <Text type="p_sm" mt={1} color={props.color}>
          {data.description[0].text || ""}
        </Text>
      </Box>
    </Box>
  );
};

export default VideoItem;
